import styled from 'styled-components'
import React from "react";
import {useFirestore} from 'react-redux-firebase'
import {useSelector} from 'react-redux'
import { useHistory } from "react-router-dom";
import {CALL_DB_PATH, COMPANY_DB_PATH, EMPLOYEE_DB_PATH} from "../constants/DB_PATHS";
import {MY_CALLS_URL} from "../constants/URLS";


export const StyledButton = styled.button`
background: ${props => props.disabled ? 'transparent' : '#70A3F1'};
border: 2px solid #70A3F1;
border-radius: 45px;
padding: 0.5rem 1.7rem;
font-family: 'Roboto', sans-serif;
font-style: normal;
font-weight: bold;
font-size: 1.4rem;
line-height: 28px;
text-transform: uppercase;
color: ${props => props.disabled ? '#70A3F1' : '#ffffff'};
&:focus {
outline: none;
}
`
export const StyledButtonRed = styled(StyledButton)`
background: ${props => props.disabled ? 'transparent' : '#e35252'};
border: 2px solid #e35252;
color: ${props => props.disabled ? '#e35252' : '#ffffff'};

`

export function TakeCallButton
({
     id,
     buttonText = 'Take Call',
 }) {
    const profile = useSelector(state => state.firebase.profile)
    const auth = useSelector(state => state.firebase.auth)
    const firestore = useFirestore()
    return (
        <button onClick={e => {
            e.preventDefault()
            //e.stopPropagation()
            console.log('take: ', id)
            if (profile.isLoaded && !profile.isEmpty) {
                firestore.collection(CALL_DB_PATH).doc(id)
                    .update({
                        takenBy: auth.uid,
                        takenByCompany: profile.companyId,
                        taken: true,
                        takeDate: new Date(),
                    })
                firestore.collection(COMPANY_DB_PATH).doc(profile.companyId)
                    .collection('takenCalls').add({
                    takeDate: new Date(),
                    employeeId: auth.uid,
                    callId: id,
                })
                firestore.collection(EMPLOYEE_DB_PATH).doc(auth.uid)
                    .collection('takenCalls').add({
                    takeDate: new Date(),
                    employeeId: auth.uid,
                    callId: id,
                })
                if (profile.role === 'company') {
                    console.log('company')


                }
                if (profile.role === 'employee') {
                    console.log('employee')

                }
            }
        }}>
            {buttonText}
        </button>
    );
}

export function FinishCallButton({id}) {
    //const profile = useSelector(state => state.firebase.profile)
    //const auth = useSelector(state => state.firebase.auth)
    const firestore = useFirestore()
    const history = useHistory()
    return (
        <button onClick={() => {
            firestore.collection(CALL_DB_PATH).doc(id)
                .update({
                    active: false,
                    finishDate: new Date(),
                }).then(()=>{
                history.push(MY_CALLS_URL)
            })
        }}>Finish</button>
    )
}